import styled, { css } from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
    margin-bottom: ${(props) => ((props.marginBottom) ? `${props.marginBottom}` : '20px')};
    ${({ flex }) => (flex ? `flex: ${flex};` : '')}
`;
Wrapper.displayName = 'Wrapper';

export const DisabledWrapper = styled.div`
    position: relative;
    ${({ disabled }) => disabled && 'cursor: not-allowed;'};
`;
DisabledWrapper.displayName = 'DisabledWrapper';

export const Title = styled.div`
    font-size: 12.5px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.09px;
    color: #afb1bc;
    margin-bottom: 8px;
    color: ${({ renderError }) => (renderError ? colors.redPink : '#afb1bc')};
    ${({ required }) => required && css`
        &::after {
            content: ' *';
            color: ${colors.redPink};
            font-weight: 700;
        }
    `}
`;
Title.displayName = 'Title';

export const CustomInput = styled.input`
    width: ${(props) => (props.width ? `${props.width}` : '224px')};
    height: ${(props) => (props.height ? `${props.height}` : '38px')};
    /* box-shadow: ${(props) => (props.renderError ? 'inset 0 -1px 0 0 #ea3158' : 'inset 0 -1px 0 0 #afafaf')}; */
    box-shadow: ${({ renderError }) => (renderError ? `inset 0 -1px 0 0 ${colors.redPink}` : 'none')};
    background-color: ${({ theme }) => theme.textfield.background};
    border: none;
    padding-left: 15px;
    padding-right: 42px;
    font-size: 14.5px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.48;
    letter-spacing: normal;
    color: ${({ theme }) => theme.textfield.text};

    ${({ disabled, theme }) => disabled &&
        `
            color: ${theme.textfield.text};
            background-color: ${theme.textfield.background};
            pointer-events: none;
        `
    };

    &.full{
        background-color: ${({ theme }) => theme.textfield.background};
    }

    &::placeholder {
        color: ${({ theme }) => theme.text.placeholder};
        font-size: 13.5px;
    }

    &:hover{
        border: 1px solid #afb1bc;
    }

    &:focus{
        background-color: ${({ theme }) => theme.textfield.focus};

        &::placeholder {
            color: transparent;
        }
    }
`;
CustomInput.displayName = 'CustomInput';
